import { render } from "./FooterCopyright.vue?vue&type=template&id=68778912"
import script from "./FooterCopyright.vue?vue&type=script&lang=js"
export * from "./FooterCopyright.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/Arham_portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__